import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import humanTime from 'flarum/common/helpers/humanTime';
import ItemList from 'flarum/common/utils/ItemList';
import MiniAvatar from './MiniAvatar';
import { sublace, formatNumber, plural } from '../../common/sublace';
import { overview } from '../states/overview';
import startDiscussion from '../startDiscussion';
import { hoverAttrs } from '../hoverCard';

/** Правая колонка главной: кнопка темы, команда онлайн, онлайн, статистика, популярное. */
export default class ForumsSidebar extends Component {
  view() {
    return m("div", {
      className: "SlSidebar"
    }, this.items().toArray());
  }
  items() {
    const items = new ItemList();
    const config = sublace();
    const data = overview();
    const canStart = app.forum.attribute('canStartDiscussion') || !app.session.user;
    items.add('newDiscussion', m(Button, {
      className: "Button Button--primary SlSidebar-new",
      icon: "fas fa-pen",
      disabled: !canStart,
      onclick: () => startDiscussion([])
    }, canStart ? 'Создать тему' : 'Нет прав на создание тем'), 100);
    if (config.showStaffOnline !== false) {
      items.add('staff', this.block('Команда онлайн', 'fas fa-shield-alt', data ? this.staff(data.staffOnline || []) : null), 90);
    }
    if (config.showOnline !== false) {
      items.add('online', this.block('Сейчас на форуме', 'fas fa-signal', data ? this.online(data.online || {
        total: 0,
        users: []
      }) : null), 80);
    }
    if (config.showPopular !== false && (!data || (data.popular || []).length)) {
      items.add('popular', this.block('Популярное за месяц', 'fas fa-fire', data ? this.popular(data.popular || []) : null), 70);
    }
    if (config.showStats !== false) {
      items.add('stats', this.block('Статистика форума', 'fas fa-chart-bar', data ? this.stats(data.stats || {}) : null), 60);
    }
    return items;
  }
  block(title, icon, content) {
    return m("section", {
      className: "SlWidget"
    }, m("h3", {
      className: "SlWidget-title"
    }, m(Icon, {
      name: icon
    }), " ", title), m("div", {
      className: "SlWidget-body"
    }, content === null ? m(LoadingIndicator, {
      size: "small",
      display: "block"
    }) : content));
  }
  staff(list) {
    if (!list.length) return m("p", {
      className: "SlWidget-empty"
    }, "\u0421\u0435\u0439\u0447\u0430\u0441 \u043D\u0438\u043A\u043E\u0433\u043E \u043D\u0435\u0442 \u2014 \u043E\u0442\u0432\u0435\u0442\u0438\u043C, \u043A\u0430\u043A \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u043E\u044F\u0432\u0438\u043C\u0441\u044F.");
    return m("ul", {
      className: "SlStaffList"
    }, list.map(user => m("li", null, m(MiniAvatar, {
      user: user,
      size: 34
    }), m("div", {
      className: "SlStaffList-info"
    }, m(Link, Object.assign({
      href: app.route('user', {
        username: user.slug || user.username
      }),
      className: "SlStaffList-name"
    }, hoverAttrs(user)), user.displayName || user.username), m("span", {
      className: "SlStaffList-group",
      style: user.groupColor ? {
        color: user.groupColor
      } : undefined
    }, user.group)))));
  }
  online(online) {
    const users = online.users || [];
    const total = online.total || 0;
    return [users.length ? m("div", {
      className: "SlOnline"
    }, users.map(user => m(MiniAvatar, {
      user: user,
      size: 30
    }))) : m("p", {
      className: "SlWidget-empty"
    }, "\u041D\u0438\u043A\u043E\u0433\u043E \u0438\u0437 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432."), m("p", {
      className: "SlWidget-foot"
    }, formatNumber(total), " ", plural(total, 'участник', 'участника', 'участников'), " \u0437\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 \u043C\u0438\u043D\u0443\u0442\u044B")];
  }
  popular(list) {
    return m("ol", {
      className: "SlPopular"
    }, list.map(d => m("li", null, m(Link, {
      href: app.route('discussion', {
        id: d.slug
      }),
      className: "SlPopular-title"
    }, d.title), m("span", {
      className: "SlPopular-meta"
    }, m(Icon, {
      name: "far fa-comment"
    }), " ", formatNumber(d.replies), " ", plural(d.replies, 'ответ', 'ответа', 'ответов'), d.lastPostedAt ? [' · ', humanTime(new Date(d.lastPostedAt))] : null))));
  }
  stats(stats) {
    return m("dl", {
      className: "SlStats"
    }, m("div", null, m("dt", null, "\u0422\u0435\u043C\u044B"), m("dd", null, formatNumber(stats.discussions))), m("div", null, m("dt", null, "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F"), m("dd", null, formatNumber(stats.posts))), m("div", null, m("dt", null, "\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438"), m("dd", null, formatNumber(stats.users))), stats.newestUser ? m("div", {
      className: "SlStats-newest"
    }, m("dt", null, "\u041D\u043E\u0432\u044B\u0439 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A"), m("dd", null, m(MiniAvatar, {
      user: stats.newestUser,
      size: 22,
      withName: true
    }))) : null);
  }
}
flarum.reg.add('sublace-forum', 'forum/components/ForumsSidebar', ForumsSidebar);